import React, {useState, useEffect, useRef} from 'react';
import {
    Card,
    CardContent,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    Grid,
    IconButton,
    TextField,
    Typography
} from "@mui/material";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import {Facebook, Google, Twitter} from "@mui/icons-material";
import Div from "@jumbo/shared/Div";
import {alpha} from "@mui/material/styles";
import {ASSET_IMAGES} from "../../../utils/constants/paths";
import {getAssetPath} from "../../../utils/appHelpers";
import * as yup from "yup";
import {Form, Formik} from "formik";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import LoadingButton from "@mui/lab/LoadingButton";
import authServices from "../../../services/auth-services";
import {useNavigate} from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import {
    gettransaction,
    login
} from "../../../../api/api";
import reCAPTCHA from "react-google-recaptcha"
import HCaptcha from "@hcaptcha/react-hcaptcha";
import Swal from "sweetalert2";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import RadioGroup from "@mui/material/RadioGroup";
import Button from "@mui/material/Button";
import backbtob from "../../../../assets/images/backbtob.png"
import mihmanshoicon3 from "../../../../assets/images/mihmanshoicon3.png"
import {useDispatch, useSelector} from "react-redux";
import {saveadmin} from "../../../redux/actions/contactsApp";

const validationSchema = yup.object({
    email: yup
        .string('Enter your email')
        .email('Enter a valid email')
        .required('Email is required'),
    password: yup
        .string('Enter your password')
        .required('Password is required'),
});


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})


const Login3 = ({disableSmLogin}) => {
    const {setAuthToken} = useJumboAuth();
    const navigate = useNavigate();
    const [number, setNumber] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [password, setPassword] = useState('');
    const [token, setToken] = useState(null);
    const captchaRef = useRef(null);
    const dispatch = useDispatch();

    const onnumber = (e) => {
        setNumber(e.target.value);
    };

    const onpassword = (e) => {
        setPassword(e.target.value);
    };


    const onSignIn = () => {
        // authServices.signIn({email, password})
        //     .then((data) => {
        //         setAuthToken(data?.token);
        //         navigate("/dashboards/misc");
        //     });

        // setAuthToken('sdssd');
        // navigate("/dashboards/misc");
        //
        // alert(number);

        setIsSubmitting(true);


        // if (token) {
        //
        // } else {
        //     Toast.fire({
        //         icon: 'error',
        //         title: 'لطفا تیک را بزنید!'
        //     })
        //     setIsSubmitting(false);
        //     return;
        // }


        if (number === '' || password === '') {

            Toast.fire({
                icon: 'error',
                title: 'لطفا نام کاربری و کلمه عبور را وارد کنید !'
            })
            setIsSubmitting(false);
            return;
        }

        // alert('ad');
        var bodyFormData2 = new FormData();
        bodyFormData2.append('username', number);
        bodyFormData2.append('password', password);

        login(bodyFormData2)
            .then((response) => {

                if (response.data.errorCode === 0) {
                    setIsSubmitting(false);
                    setAuthToken(response.data.token)
                    localStorage.setItem('token', 'Token ' + response.data.token);
                    localStorage.setItem('sd', 'sds');
                    console.log(response.data.profile.type);

                    if(response.data.profile.type===2){
                        dispatch(saveadmin(true));
                    }else {
                        dispatch(saveadmin(false));
                    }

                    navigate("/");

                } else {
                    Toast.fire({
                        icon: 'error',
                        title: response.data.errorDescription
                    })
                    setIsSubmitting(false);
                }

            })
            .catch((error) => {
                setIsSubmitting(false);
            });
    };


    const onlogin = () => {


        alert('as')


    };


    const onExpire = () => {
        console.log("hCaptcha Token Expired");
    };

    const onError = (err) => {
        console.log(`hCaptcha Error: ${err}`);
    };


    useEffect(() => {

        if (token) {
            // alert(token);
        }


    }, [token]);
    useEffect(() => {


        let tk=localStorage.getItem('token');

        if(tk===""||tk===null){

        }else {
            navigate("/");

        }
    }, []);

    return (
        <div style={{display: 'flex', width: '100%', height: '100%', flexDirection: 'row'}}>
            <Grid style={{width: '100%'}} container>
                <Grid style={{width: '100%'}} item lg={6}>
                    <Div sx={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        p: 4
                    }}>
                        <Card
                            sx={{
                                display: 'flex',
                                minWidth: 0,
                                flexDirection: {xs: 'column', md: 'row'}
                            }}
                        >
                            <CardContent
                                sx={{
                                    flex: '0 1 300px',
                                    position: 'relative',
                                    background: `#0267a0 url(${getAssetPath(`${ASSET_IMAGES}/widgets/keith-luke.jpg`, "640x428")}) no-repeat center`,
                                    backgroundSize: 'cover',

                                    '&::after': {
                                        display: 'inline-block',
                                        position: 'absolute',
                                        content: `''`,
                                        inset: 0,
                                        backgroundColor: alpha('#0267a0', .65)
                                    }
                                }}
                            >
                                <Div
                                    sx={{
                                        display: 'flex',
                                        minWidth: 0,
                                        flex: 1,
                                        flexDirection: 'column',
                                        color: 'common.white',
                                        position: 'relative',
                                        zIndex: 1,
                                        height: '100%'
                                    }}
                                >
                                    <Div sx={{mb: 2}}>
                                        <Typography style={{fontFamily: 'Iran'}} className="iran-font" variant={"h3"}
                                                    color={"inherit"}
                                                    fontWeight={500} mb={3}>ورود به
                                            سیستم</Typography>
                                        <Typography style={{fontFamily: 'Iran'}} variant={"body1"} mb={2}>
                                            برای ورود نام کاربری و کلمه عبور را وارد کنید
                                        </Typography>
                                        {/*<Typography variant={"body1"}>*/}
                                        {/*    <Link style={{fontFamily: 'Iran'}}*/}
                                        {/*          href={"#"}*/}
                                        {/*          color={"inherit"}*/}
                                        {/*          underline={'none'}*/}
                                        {/*    >رمز خود را فراموش کرده اید ؟ آن را بازیابی کنید*/}
                                        {/*    </Link>*/}
                                        {/*</Typography>*/}
                                    </Div>
                                    <Div sx={{mt: 'auto'}}>
                                        <Link href="#" underline="none" sx={{display: 'inline-flex'}}>
                                            {/*<img src={`${ASSET_IMAGES}/logo-white.png`} alt="Jumbo React"/>*/}

                                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>

                                                <img style={{width:50,height:50}} src={mihmanshoicon3} alt="Jumbo React"/>

                                                <div style={{fontFamily: 'Iran',fontWeight:'bold',marginRight:10,color:'#ffffff'}}>میهمان شو </div>


                                            </div>


                                        </Link>
                                    </Div>
                                </Div>
                            </CardContent>
                            <CardContent sx={{flex: 1, p: 4}}
                            >


                                <div style={{textAlign: 'left'}}>
                                    <Div sx={{mt: 1, mb: 3}} style={{fontFamily: 'Iran'}}>
                                        <TextField
                                            inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                            InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                            style={{fontFamily: 'Iran'}}
                                            fullWidth
                                            onChange={onnumber}
                                            value={number}
                                            name="email"
                                            label="نام کاربری"
                                        />
                                    </Div>
                                    <Div sx={{mt: 1, mb: 2}} style={{fontFamily: 'Iran'}}>
                                        <TextField
                                            inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                            InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                            style={{fontFamily: 'Iran'}}
                                            fullWidth
                                            value={password}
                                            onChange={onpassword}
                                            name="password"
                                            label="کلمه عبور"
                                            type="password"
                                        />
                                    </Div>


                                    {/*<HCaptcha*/}
                                    {/*    // This is testing sitekey, will autopass*/}
                                    {/*    // Make sure to replace*/}
                                    {/*    // sitekey="10000000-ffff-ffff-ffff-000000000001"*/}
                                    {/*    sitekey="0ca73890-fb27-41e6-a397-f728458779f6"*/}
                                    {/*    languageOverride="fa"*/}
                                    {/*    onVerify={setToken}*/}
                                    {/*    onError={onError}*/}
                                    {/*    onExpire={onExpire}*/}
                                    {/*    ref={captchaRef}*/}

                                    {/*/>*/}


                                    {/*<Div sx={{mb: 2}}>*/}
                                    {/*    <FormControlLabel control={<Checkbox/>} label="Remember me"/>*/}
                                    {/*</Div>*/}
                                    <LoadingButton
                                        style={{fontFamily: 'Iran'}}
                                        onClick={onSignIn}
                                        fullWidth
                                        type="submit"
                                        variant="contained"
                                        size="large"
                                        sx={{mb: 3, mt: 1}}
                                        loading={isSubmitting}
                                    >ورود</LoadingButton>


                                </div>


                            </CardContent>
                        </Card>
                    </Div>
                </Grid>
                <Grid style={{width: '100%', paddingRight: 10}} item lg={6}>

                    <div style={{width: '100%', height: '100%'}}>

                        <img style={{width: '100%', height: '100%'}} src={backbtob}/>


                    </div>


                </Grid>
            </Grid>
        </div>
    )
        ;
};

export default Login3;
